export const APP_NOTIFICATION_SHOWN = 'APP_NOTIFICATION_SHOWN';
export const APP_OPTIONS_SET = 'APP_OPTIONS_SET';
export const THEME_AND_SETTINGS_FETCHED = 'THEME_AND_SETTINGS_FETCHED';
export const THEME_SETTINGS_VARIANT_FETCHED = 'THEME_SETTINGS_VARIANT_FETCHED';
export const THEME_SETTINGS_BUFFER_PUBLISHED = 'THEME_SETTINGS_BUFFER_PUBLISHED';
export const THEME_SETTINGS_BUFFER_SAVED = 'THEME_SETTINGS_BUFFER_SAVED';
export const THEME_SETTINGS_REVERTED = 'THEME_SETTINGS_REVERTED';
export const THEME_SETTINGS_REVISIONS_FETCHED = 'THEME_SETTINGS_REVISIONS_FETCHED';
export const THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES = 'THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES';
export const THEME_SETTINGS_CHANGE_REDONE = 'THEME_SETTINGS_CHANGE_REDONE';
export const THEME_SETTINGS_CHANGE_UNDONE = 'THEME_SETTINGS_CHANGE_UNDONE';
export const THEME_SETTINGS_FIELD_KEY_UPDATED = 'THEME_SETTINGS_FIELD_KEY_UPDATED';
export const THEME_SETTINGS_UPDATED = 'THEME_SETTINGS_UPDATED';
export const THEME_SETTINGS_CLEARED = 'THEME_SETTINGS_CLEARED';
export const THEME_SETTINGS_RESET = 'THEME_SETTINGS_RESET';
export const PREVIEW_IFRAME_READY = 'PREVIEW_IFRAME_READY';
export const RELOAD_IFRAME_PREVIEW = 'RELOAD_IFRAME_PREVIEW';
export const IFRAME_PREVIEW_LOADED = 'IFRAME_PREVIEW_LOADED';
export const IFRAME_PREVIEW_LOAD_FAILED = 'IFRAME_PREVIEW_LOAD_FAILED';
export const SET_IFRAME_PREVIEW_LOADING = 'SET_IFRAME_PREVIEW_LOADING';
export const THEME_FIELD_FOCUSED = 'THEME_FIELD_FOCUSED';
export const THEME_FIELD_BLURRED = 'THEME_FIELD_BLURRED';
export const FETCH_THEME_DEPENDENTS = 'FETCH_THEME_DEPENDENTS';
export const CLEAR_UPDATED_THEME_SETTINGS = 'CLEAR_UPDATED_THEME_SETTINGS';
export const FETCH_PREVIEW_KEY = 'FETCH_PREVIEW_KEY';
export const SET_IFRAME_TIMEOUT_ERROR = 'SET_IFRAME_TIMEOUT_ERROR';
export const CLEAR_IFRAME_TIMEOUT_ERROR = 'CLEAR_IFRAME_TIMEOUT_ERROR';
export const FETCH_TEMPLATE = 'FETCH_TEMPLATE';
export const FETCH_PREVIEW_DOMAIN = 'FETCH_PREVIEW_DOMAIN';
export const UPDATE_PREVIEW_URL = 'UPDATE_PREVIEW_URL';
export const SET_IGNORE_USER_THEME_OVERRIDES = 'SET_IGNORE_USER_THEME_OVERRIDES';
export const FETCH_SITE_PAGES_USAGE = 'FETCH_SITE_PAGES_USAGE';
export const FETCH_BLOGS_USAGE = 'FETCH_BLOGS_USAGE';
export const CREATE_BLOG_POST = 'CREATE_BLOG_POST';
export const FETCH_BLOGS = 'FETCH_BLOGS';
export const FETCH_FAVORITE_BLOG = 'FETCH_FAVORITE_BLOG';
export const FETCH_DOMAINS = 'FETCH_DOMAINS';
export const OPEN_PATAGONIA_ONBOARDING_MODAL = 'OPEN_PATAGONIA_ONBOARDING_MODAL';
export const CLOSE_PATAGONIA_ONBOARDING_MODAL = 'CLOSE_PATAGONIA_ONBOARDING_MODAL';
export const SET_COMMERCE_TASK_GUIDE_MODAL_OPEN = 'SET_COMMERCE_TASK_GUIDE_MODAL_OPEN';
export const UPDATE_BREAKPOINT = 'UPDATE_BREAKPOINT';
export const FETCH_PRESETS = 'FETCH_PRESETS';
export const SET_SELECTED_PRESET = 'SET_SELECTED_PRESET';
export const CLEAR_SELECTED_PRESET = 'CLEAR_SELECTED_PRESET';
export const SET_ACTIVE_PRESET = 'SET_ACTIVE_PRESET';
export const CLEAR_ACTIVE_PRESET = 'CLEAR_ACTIVE_PRESET';
export const SET_IS_PRESET_PANEL_OPEN = 'SET_IS_PRESET_PANEL_OPEN';
export const FETCH_THEME_SUCCEEDED = 'FETCH_THEME_SUCCEEDED';
export const FETCH_CONTENT_SCHEMA_SUCCEEDED = 'FETCH_CONTENT_SCHEMA_SUCCEEDED';
export const CLEAR_THEME_SETTINGS_REVISIONS = 'CLEAR_THEME_SETTINGS_REVISIONS';

//CEUI UNIVERSAL THEME ACTIONS
export const MODULE_REDUCER_CHANGE_UNDO = 'MODULE_REDUCER_CHANGE_UNDO';
export const MODULE_REDUCER_CHANGE_REDO = 'MODULE_REDUCER_CHANGE_REDO';
export const SET_UNIVERSAL_SCROLL_TO_FIELD_PATH = 'SET_UNIVERSAL_SCROLL_TO_FIELD_PATH';